<template>
  <nav class="social-bar">
    <a class="social-link" :href="links.x" target="_blank" rel="noreferrer" aria-label="X">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M18.9 2H22l-6.77 7.74L23.2 22h-6.26l-4.9-6.39L6.45 22H3.34l7.24-8.28L.8 2h6.42l4.43 5.86L18.9 2Zm-1.1 18.1h1.74L5.33 3.8H3.46Z" />
      </svg>
    </a>
    <a class="social-link" :href="links.telegram" target="_blank" rel="noreferrer" aria-label="Telegram">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M21.4 4.6 18.2 20c-.24 1.08-.87 1.35-1.76.84l-4.87-3.6-2.35 2.27c-.26.26-.48.48-.98.48l.35-4.97 9.04-8.17c.4-.35-.08-.55-.61-.2L6.36 13.4 1.78 11.97c-1-.31-1.02-1 .2-1.47l17.9-6.9c.83-.3 1.56.2 1.3 1Z" />
      </svg>
    </a>
    <a
      class="social-link debox"
      :href="links.debox || '#'"
      target="_blank"
      rel="noreferrer"
      aria-label="DeBox"
      @click.prevent="handleDeboxClick"
    >
      <span>DB</span>
    </a>
  </nav>
</template>

<script>
import { DAPP_CONFIG } from '../config/dapp'

export default {
  name: 'SocialBar',
  data() {
    return {
      links: DAPP_CONFIG.socialLinks,
    }
  },
  methods: {
    handleDeboxClick() {
      if (this.links.debox) {
        window.open(this.links.debox, '_blank')
      }
    },
  },
}
</script>

<style scoped>
.social-bar {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  background: rgba(12, 6, 0, 0.98);
  border-top: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 10px 16px max(10px, env(safe-area-inset-bottom));
  z-index: 100;
  backdrop-filter: blur(16px);
}

.social-link {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  border: 1px solid var(--border);
  background: rgba(245, 200, 66, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gold);
  transition: transform 0.15s, border-color 0.15s, background 0.15s;
}

.social-link svg {
  width: 24px;
  height: 24px;
  display: block;
  fill: currentColor;
}

.social-link.debox span {
  font-family: 'Orbitron', monospace;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0.6px;
}

.social-link.disabled {
  opacity: 0.55;
}
</style>


